export const getFilesLoading            = (state)   => state.files.isLoading; 
export const getFirmwaresData           = (state)   => state.files.firmwaresData;
export const getConfigFilesData         = (state)   => state.files.configData;
export const getFirmwareDialogStatus    = (state)   => state.files.isFirmwareDialogOpen;
export const getConfigDialogStatus      = (state)   => state.files.isConfigDialogOpen;

export const getEventLogFilesLoading    = (state)   => state.eventLogFiles.isLoading; 
export const getEventLogsFileData       = (state)   => state.eventLogFiles.eventLogFilesList;

export const getToolTipsLoading         = (state)   => state.tooltips.isLoading; 
export const getTooltipsData            = (state)   => state.tooltips.toolTipData; 
export const getTooltipDialogStatus     = (state)   => state.tooltips.isTooltipDialogOpen;
export const getLastEventId             = (state)   => state.tooltips.lastEventId;
export const getSingleTooltipData       = (state)   => state.tooltips.eventTooltipData;

export const getChangeLogFilesLoading  = (state)   => state.changelog.isLoading; 
export const getChangeLogFileData      = (state)   => state.changelog.changeLogListData;
export const getChangeLogTypeList      = (state)   => state.changelog.changeLogTypeList;
export const getChangeLogSubTypeList   = (state)   => state.changelog.changeLogSubTypeList;

export const getRemoteDeviceLoading = (state) => state.remoteDeviceData.isLoading; 
export const getRemoteDeviceList    = (state) => state.remoteDeviceData.remoteDeviceList;

export const getDashboardLoading    = (state) => state.dashboardData.isLoading;
export const getWidgetData          = (state) => state.dashboardData.widgetData;
export const getWidgetsList         = (state) => state.dashboardData.widgetsList;
export const getUserWidgetsList     = (state) => state.dashboardData.userWidgetsList;

export const getRoleLoading         = (state) => state.roleData.isLoading; 
export const getRoleList            = (state) => state.roleData.roleListData;
export const getRoleDialogStatus    = (state) => state.roleData.isRoleDialogOpen;

export const getUserLoading         = (state) => state.userData.isLoading; 
export const getUserList            = (state) => state.userData.userListdata;
export const getAppUserList         = (state) => state.userData.appUserdata;
export const getUserDialogStatus    = (state) => state.userData.isUserDialogOpen;
export const getRolesList           = (state) => state.userData.rolesData;
export const getUserPermissionsList = (state) => state.userData.userPermissionsData;

export const getRolesLoading        = (state) => state.permissionData.isLoading;
export const getAdminRolesList      = (state) => state.permissionData.adminRolesData;
export const getRolePermissionsList = (state) => state.permissionData.rolePermissionsData;
export const getPermissions         = (state) => state.permissionData.permissionsData;

export const getUserDetailsLoading       = (state) => state.elevationData.isLoading; 
export const getUserDetails              = (state) => state.elevationData.currentUserData;
export const getRoleChangeRequests       = (state) => state.elevationData.roleChangeRequestData;
export const getPermissionChangeRequests = (state) => state.elevationData.permissionChangeRequestData;
export const getUserPermissionList       = (state) => state.elevationData.userPermissionsList;

export const getuserPermissionsRolesLoading  = (state) => state.userPermissionRoleData.isLoading;
export const getuserPermissionsRolesInfo     = (state) => state.userPermissionRoleData.userPermissionsRolesInfo;
export const getuserPermissionsRolesNotFound = (state) => state.userPermissionRoleData.userPermissionsRolesNotFound;
export const getuserPermissionsRolesLoaded   = (state) => state.userPermissionRoleData.loaded;

export const getAppRolesLoading               = (state) => state.controllerPermissionData.isLoading;
export const getAppRolesList                  = (state) => state.controllerPermissionData.appRolesData;
export const getControllersList               = (state) => state.controllerPermissionData.controllersListData;
export const getControllersTenantPermission   = (state) => state.controllerPermissionData.controllersTenantPermission;
export const getTenantRoles                   = (state) => state.controllerPermissionData.tenantRolesList;
export const getControllerRolePermissionsList = (state) => state.controllerPermissionData.controllerRolePermissionList;

export const getInterpretationFilesLoading      = (state) => state.interpretationFileData.isLoading; 
export const getInterpretationFilesList         = (state) => state.interpretationFileData.interpretationData;
export const getInterpretationFilesDialogStatus = (state) => state.interpretationFileData.isInterpretationFileDialogOpen;

export const getUnitsAndEnumsLoading            = (state) => state.unitAndEnumData.isLoading; 
export const getUnitsAndEnumsList               = (state) => state.unitAndEnumData.unitEnumData;
export const getUnitsAndEnumsDialogStatus       = (state) => state.unitAndEnumData.isUnitsAndEnumsDialogOpen;
export const getUnitAndEnumSingleData           = (state) => state.unitAndEnumData.unitEnumSingleData;

export const getEnumsLoading                    = (state) => state.enumData.isLoading; 
export const getEnumsList                       = (state) => state.enumData.enumArrayData;
export const getEnumsDialogStatus               = (state) => state.enumData.isEnumsDialogOpen;
export const getEnumSingleData                  = (state) => state.enumData.enumSingleData;

export const getEnumsGroupLoading               = (state) => state.enumGroupData.isLoading; 
export const getEnumsGroupList                  = (state) => state.enumGroupData.enumGroupArrayData;
export const getEnumsGroupDialogStatus          = (state) => state.enumGroupData.isEnumsGroupDialogOpen;
export const getEnumGroupSingleData             = (state) => state.enumGroupData.enumGroupSingleData;

export const getAccessCodeLoading               = (state) => state.accessCodeData.isLoading; 
export const getAccessCodeList                  = (state) => state.accessCodeData.accessCodeList;
export const getAccessCodeDialogStatus          = (state) => state.accessCodeData.isAccessCodeDialogOpen;
export const getAccessCodeLoginUserName         = (state) => state.accessCodeData.loginUserName;

export const getAutoCompleteUsersLoading        = (state) => state.autoCompleteData.isLoading;
export const getAutoCompleteUsersList           = (state) => state.autoCompleteData.usersList;